var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./minubaBudgetSingleProjects.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1a9e3da2\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./minubaBudgetSingleProjects.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/components/minubaBudgetSingleProjects.vue
// module id = 247
// module chunks = 0